import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, ChevronLeft, ChevronRight, Plus, X } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2, createPricePlanByAdmin, getAPricePlanByProductId } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import AppMenuCardBlueBGTwo from "../AppCards/AppMenuCardBlueBGTwo";
import { DayPicker } from "react-day-picker";
import Toggle from "../../UI/Toggle";
import SkillsProductAddMore from "../CreateProduct/SkillsProductAddMore";
import InstallmentPlanAddMore from "./InstallmentPlanAddMore";
const CreatePricePlan = ({setActiveCardOverview,baseUrl,producttype})=>{

  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const [activeStep, setActiveStep] = useState(0);
 const [activeSubStepOne, setActiveSubStepOne] = useState(3);
 
 const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
 const [activeSubStepThree, setActiveSubStepThree] = useState(0);
 const [activeSubStepFour, setActiveSubStepFour] = useState(0);
 const [activeSubStepFive, setActiveSubStepFive] = useState(0);
 
const steps = ([{number:1,name:"Price"},{number:2,name:"Expiry & Privacy"},{number:3,name:"Upsale & Coupons"}]);
const subSteps = [1, 2, 3, 4, 5];
const subStepOneTotal= 3;
const subStepTwoTotal= 3;
const subStepThreeTotal= 4;
const subStepFourTotal= 8;
const subStepFiveTotal= 1;
;
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

const [loader , setLoader] =useState({status:false});
const [loaderPriceType , setLoaderPriceType] =useState({status:false});
  const [pricePlan, setPricePlanObject] = useState("");
 const [editType, setEditType] = useState(courseData?.ID?"productName":"");
 const [pricePlanTypeStatus, setPricePlanTypeStatus] = useState(false);

 const [pricePlanType, setPricePlanType] = useState();
 const [regularPriceWeb, setRegularPriceWeb] = useState();
 const [discountPriceWeb, setDiscountPriceWeb] = useState();
 const [effectivePriceWeb, setEffectivePriceWeb] = useState();
 const [discountStatusWeb, setDiscountStatusWeb] = useState();
 const [regularPriceAndroid, setRegularPriceAndroid] = useState();
 const [discountPriceAndroid, setDiscountPriceAndroid] = useState();
 const [effectivePriceAndroid, setEffectivePriceAndroid] = useState();
 const [discountStatusAndroid, setDiscountStatusAndroid] = useState();
 const [regularPriceiOS, setRegularPriceiOS] = useState();
 const [discountPriceiOS, setDiscountPriceiOS] = useState();
 const [effectivePriceiOS, setEffectivePriceiOS] = useState();
 const [discountStatusiOS, setDiscountStatusiOS] = useState();
 const [discountScheduleStartWeb, setDiscountScheduleStartWeb] = useState();
 const [setDiscountScheduleStatus, updateDiscountScheduleStatus] = useState();
 const [platformWeb, setPlatformWeb] = useState();
 const [platformAndroid, setPlatformAndroid] = useState();
 const [platformiOS, setPlatformiOS] = useState();
 
 const [setPricesDiffferentlyForRenewalUsers, updateSetPricesDiffferentlyForRenewalUsers] = useState();

 const [regularPriceRenewalUsers, setRegularPriceRenewalUsers] = useState();
 const [discountPriceRenewalUsers, setDiscountPriceRenewalUsers] = useState();
 const [effectivePriceRenewalUsers, setEffectivePriceRenewalUsers] = useState();
 const [discountStatusRenewalUsers, setDiscountStatusRenewalUsers] = useState();
 const [addDiffPricesForRenewalUsersPopUp, setAddDiffPricesForRenewalUsersPopUp] = useState();
 const [setPricesDiffferentlyForPlatforms, updateSetPricesDiffferentlyForPlatforms] = useState();
 const [allowInstallmentPrices, updateAllowInstallmentPrices] = useState();
 const [addDiffPricesForDevicesPopUp, setAddDiffPricesForDevicesPopUp] = useState();
 
 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);
 const [itemArr, setItemArr] = useState([]);

     useEffect(() => {
      
          
  
     }, []);
    
    
   
     function generateTimestamp() {
      return Math.floor(Date.now() / 1000);
    }

    const removeItem = (id) => {
      const filteredItems = itemArr.filter(item => item.id !== id);
      setItemArr(filteredItems);
      
      handleCreatePricePlan("installmentValues",filteredItems)
    };
    const updateItemValue = (id, Value) => {
      const updatedItems = itemArr.map(item =>
        item.id === id ? { ...item, value :Value } : item
      
      ); 
      
      setItemArr(updatedItems);


      handleCreatePricePlan("installmentValues",updatedItems)
    };
   
  const flattenedData = itemArr!=[]?Object.values(itemArr):'';


 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
   
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  fireGetAPricePlanByProductId()
},[])

const fireGetAPricePlanByProductId=()=>{
  setAnimate(false);  
 let  sendObject= {productIds:courseData?.ID,type:"pricePlan",visibility:"public",orderBy:"ASC",
      userEmail:user_email?user_email:"",
       currentToken:currentToken?currentToken:"",
       appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
 
  
  setLoader({status:true});
  
    const apiData = dispatch(getAPricePlanByProductId(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        
        setPricePlanTypeStatus(true)
        console.log(response);
        if(response?.pricePlan){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  // setSnackbarVisible(true);
  setTimeout(()=>{
   
    // (response?.pricePlan?.effectivePriceiOS&&response?.pricePlan?.effectivePriceWeb&&response?.pricePlan?.effectivePriceAndroid)?setActiveSubStepOne(3)
    // :(response?.pricePlan?.effectivePriceiOS&&response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(2)
    // :(response?.pricePlan?.effectivePriceAndroid&&response?.pricePlan?.effectivePriceiOS)?setActiveSubStepOne(2)
    // :(response?.pricePlan?.effectivePriceAndroid&&response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(2)
    // : (response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(1)
    // : (response?.pricePlan?.effectivePriceAndroid)?setActiveSubStepOne(1)
    // : (response?.pricePlan?.effectivePriceiOS)?setActiveSubStepOne(1): setActiveSubStepOne(0);
    setSnackbarVisible(false);
     setPricePlanType(response?.pricePlan?.pricePlanType)
    setPricePlanObject(response?.pricePlan);
    setRegularPriceWeb(response?.pricePlan?.regularPriceWeb)
    setDiscountPriceWeb(response?.pricePlan?.discountPriceWeb)
    setEffectivePriceWeb(response?.pricePlan?.effectivePriceWeb)
     setRegularPriceAndroid(response?.pricePlan?.regularPriceAndroid)
    setDiscountPriceAndroid(response?.pricePlan?.discountPriceAndroid)
    setEffectivePriceAndroid(response?.pricePlan?.effectivePriceAndroid)
    setRegularPriceiOS(response?.pricePlan?.regularPriceiOS)
    setDiscountPriceiOS(response?.pricePlan?.discountPriceiOS)
    setEffectivePriceiOS(response?.pricePlan?.effectivePriceiOS)
    setRegularPriceRenewalUsers(response?.pricePlan?.regularPriceRenewalUsers)
    setDiscountPriceRenewalUsers(response?.pricePlan?.discountPriceRenewalUsers)
    setEffectivePriceRenewalUsers(response?.pricePlan?.effectivePriceRenewalUsers)
    setDiscountScheduleStartWeb(response?.pricePlan?.discountScheduleStartWeb)
    setSelectedDate(response?.pricePlan?.discountScheduleStartWeb?JSON.parse(response?.pricePlan?.discountScheduleStartWeb)?.selected:"");
    setSelected(formatDateString(response?.pricePlan?.discountScheduleStartWeb?JSON.parse(response?.pricePlan?.discountScheduleStartWeb)?.selected:""));
    updateDiscountScheduleStatus(JSON.parse(response?.pricePlan?.setDiscountScheduleStatus))
    setPlatformWeb(JSON.parse(response?.pricePlan?.platformWeb))
    setPlatformAndroid(JSON.parse(response?.pricePlan?.platformAndroid))
    setPlatformiOS(JSON.parse(response?.pricePlan?.platformiOS))
    updateSetPricesDiffferentlyForPlatforms(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForPlatforms))
    updateSetPricesDiffferentlyForRenewalUsers(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForRenewalUsers))
    updateAllowInstallmentPrices(JSON.parse(response?.pricePlan?.allowInstallmentPrices))
    setItemArr(response?.pricePlan?.installmentValues?JSON.parse(response?.pricePlan?.installmentValues):[{ no:1, id: generateTimestamp()+1
      ,value:{amount:100,validityCount:3,validityDurationType:"days"} },{ no:2, id: generateTimestamp()+2
          ,value:{amount:2000,validityCount:1,validityDurationType:"months"} },])
          setAnimate(true);  
  },1000)
     }else{
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }


  const handleCreatePricePlan=(editType,sendDataValue)=>{
    setAnimate(false);  
  let sendObject;
  if(editType=="pricePlanType"){
    setLoader({...loader,status:true});
   sendObject= {pricePlanType:sendDataValue,productIds:courseData?.ID,type:"pricePlan",
      userEmail:user_email?user_email:"",
       currentToken:currentToken?currentToken:"",
       editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
  } if(editType=="priceWeb"){
    setLoader({...loader,status:true});
    sendObject= {regularPriceWeb:sendDataValue?.regularPriceWeb,discountPriceWeb:sendDataValue?.discountPriceWeb,effectivePriceWeb:sendDataValue?.effectivePriceWeb,productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editType=="priceAndroid"){
    setLoader({...loader,status:true});
    sendObject= {regularPriceAndroid:sendDataValue?.regularPriceAndroid,discountPriceAndroid:sendDataValue?.discountPriceAndroid,effectivePriceAndroid:sendDataValue?.effectivePriceAndroid,productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editType=="priceiOS"){
    setLoader({...loader,status:true});
    sendObject= {regularPriceiOS:sendDataValue?.regularPriceiOS,discountPriceiOS:sendDataValue?.discountPriceiOS,effectivePriceiOS:sendDataValue?.effectivePriceiOS,productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editType=="priceRenewalUsers"){
    setLoader({...loader,status:true});
    sendObject= {regularPriceRenewalUsers:sendDataValue?.regularPriceRenewalUsers,discountPriceRenewalUsers:sendDataValue?.discountPriceRenewalUsers,effectivePriceRenewalUsers:sendDataValue?.effectivePriceRenewalUsers,productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="discountScheduleStartWeb"){
    setLoader({...loader,status:true});
    sendObject= {discountScheduleStartWeb:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="setDiscountScheduleStatus"){
    setLoader({...loader,statusDiscountSchedule:true,status:true});
    sendObject= {setDiscountScheduleStatus:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="platformWeb"){
    setLoader({...loader,statusPlatformWeb:true,status:true});
    sendObject= {platformWeb:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="platformAndroid"){
    setLoader({...loader,statusPlatformAndroid:true,status:true});
    sendObject= {platformAndroid:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="platformiOS"){
    setLoader({...loader,statusPlatformiOS:true,status:true});
    sendObject= {platformiOS:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="setPricesDiffferentlyForPlatforms"){
    setLoader({...loader,statusSetPricesDiffferentlyForPlatforms:true,status:true});
    sendObject= {setPricesDiffferentlyForPlatforms:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   } if(editType=="allowInstallmentPrices"){
    setLoader({...loader,statusAllowInstallmentPrices:true,status:true});
    sendObject= {allowInstallmentPrices:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   } if(editType=="setPricesDiffferentlyForRenewalUsers"){
    setLoader({...loader,statusSetPricesDiffferentlyForRenewalUsers:true,status:true});
    sendObject= {setPricesDiffferentlyForRenewalUsers:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="installmentValues"){
    setLoader({...loader,statusInstallmentValues:true,status:true});
    sendObject= {installmentValues:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   
   
  
    const apiData = dispatch(createPricePlanByAdmin(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){console.log(response);
        if(response?.pricePlan){
          if(editType!="priceWeb"&&editType!="priceAndroid"&&editType!="priceiOS"&&editType!="priceRenewalUsers"&&editType!="discountScheduleStartWeb"&&editType!="setDiscountScheduleStatus"&&editType!="setPricesDiffferentlyForPlatforms"&&editType!="allowInstallmentPrices"&&editType!="setPricesDiffferentlyForRenewalUsers"&&editType!="installmentValues"){
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
          
  setSnackbarVisible(true);
          }
                
          setLoader({...loader,statusDiscountSchedule:false,statusPlatformWeb:false,statusPlatformAndroid:false,statusPlatformiOS:false,statusSetPricesDiffferentlyForPlatforms:false,status:false});
           
  setTimeout(()=>{
   
    // (response?.pricePlan?.effectivePriceiOS&&response?.pricePlan?.effectivePriceWeb&&response?.pricePlan?.effectivePriceAndroid)?setActiveSubStepOne(3)
    // :(response?.pricePlan?.effectivePriceiOS&&response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(2)
    // :(response?.pricePlan?.effectivePriceAndroid&&response?.pricePlan?.effectivePriceiOS)?setActiveSubStepOne(2)
    // :(response?.pricePlan?.effectivePriceAndroid&&response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(2)
    // : (response?.pricePlan?.effectivePriceWeb)?setActiveSubStepOne(1)
    // : (response?.pricePlan?.effectivePriceAndroid)?setActiveSubStepOne(1)
    // : (response?.pricePlan?.effectivePriceiOS)?setActiveSubStepOne(1): setActiveSubStepOne(0);
   
    setSnackbarVisible(false);
   
    setPricePlanObject(response?.pricePlan);
    updateDiscountScheduleStatus(JSON.parse(response?.pricePlan?.setDiscountScheduleStatus))
    setPlatformWeb(JSON.parse(response?.pricePlan?.platformWeb))
    setPlatformAndroid(JSON.parse(response?.pricePlan?.platformAndroid))
    setPlatformiOS(JSON.parse(response?.pricePlan?.platformiOS))
    updateSetPricesDiffferentlyForPlatforms(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForPlatforms))
    
    updateSetPricesDiffferentlyForRenewalUsers(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForRenewalUsers))
    updateAllowInstallmentPrices(JSON.parse(response?.pricePlan?.allowInstallmentPrices))
    setItemArr(response?.pricePlan?.installmentValues?JSON.parse(response?.pricePlan?.installmentValues):[])
    setAnimate(true);  
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    

    const [selected, setSelected] = useState(null);


       const [selectedDate, setSelectedDate] = useState(null);
            const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
            const [startYear, setStartYear] = useState(2020);
            const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
            const [statusYear,setStatusYear]=useState(false)
            const [statusMonth,setStatusMonth]=useState(false)
            const [statusCalendar,setStatusCalendar]=useState(true)
            const [startDate,setStartDate]=useState("")
            const [endDate,setEndDate]=useState("")
            
            function getYearAndMonth(dateString) {
              // Split the input string by the '-' delimiter
              const [day, month, year] = dateString.split('-');
          
              // Return an object containing the year and month
              return {
                  year: parseInt(year, 10),
                  month: parseInt(month, 10)
              };
          }
          
         
const modifiers = {
    weekend: { dayOfWeek: [0, 6] },  // Highlight weekends
    // holiday: [new Date(2024, 11, 25), new Date(2024, 0, 1)] ,

    //   start: selected?.from,       // Modifier for the start date
    //     end: selected?.to 
  };
  
  const modifiersStyles = {
    weekend: {   borderRadius:"50%",background:"#f1f1f1"},
    // holiday: { color: "red", backgroundColor: "yellow" },
    selected:{ backgroundColor: "rgba(149, 143, 218,0.11)", },
    start: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"},       // Class for the start date
        end: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"}
  };
 
 useEffect(() => {
     
     
     if(pricePlan?.discountScheduleStartWeb?.date){
      // const date = new Date(courseData?.CourseDuration?.validityValue?.expiryDate?.date);
       // Example usage
    const date = pricePlan?.discountScheduleStartWeb?.date;
    const result = getYearAndMonth(date);
   setSelectedMonth(result?.month-1);
  setSelectedYear(result?.year);
     } 
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
       
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, [pricePlan?.ID]);
    
    
  const handleDayClick = (day) => {
     // alert(`You clicked ${date.toDateString()}`);
    //  console.log(formatDateString(day))
setSelected(formatDateString(day));
handleCreatePricePlan("discountScheduleStartWeb",{selected:day,from:formatDateString(day?.from),to:formatDateString(day?.to)});

    //  console.log({selected:day,date:formatDateString(day)})
   
  };
  function formatDateString(dateString) {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  // Format as "DD-MM-YYYY"
  return `${day}-${month}-${year}`;
}










  const handlePrevious = () => {
    setStartYear((prev) => Math.max(1900, prev - 10));
  };

  const handleNext = () => {
    setStartYear((prev) => Math.min(2100 - 9, prev + 10));
   
  };

  const handleSelectMonth = (month) => {
    setSelectedMonth(month);setStatusMonth(false)
    setStatusCalendar(true)
  };
  function YearGrid({ startYear, onSelectYear, selectedYear, onPrevious, onNext }) {
    const years = Array.from({ length: 10 }, (_, i) => startYear + i);
  
    return (
      <div style={{width:"320px",marginBottom: "10px" ,marginTop: "10px"}}>
        <div style={{ display: "flex",
             justifyContent: "space-between" , padding:"10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",marginBottom: "10px" ,marginTop: "10px"}}>
       
    <div  onClick={()=>{setStatusYear(false)
        setStatusMonth(false);
    setStatusCalendar(true)}} style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
    ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     
     <button style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"80px",
         border: `${startYear <= 1900
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`,borderRadius:"10px",}} 
         onClick={onPrevious} disabled={startYear <= 1900}>
            Previous
          </button>
          <div style={{padding:"5px"}}>Select Year</div>
          <button  style={{ fontSize:"14px",padding:"6px",textAlign:"center",
            cursor:"pointer",width:"80px", border: 
            `${startYear + 25 > 2100
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`
            ,borderRadius:"10px",}} onClick={onNext} disabled={startYear + 25 > 2100}>
            Next
          </button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",}}>
          {years.map((year) => (
            <button
              key={year}
              onClick={() => {onSelectYear(year);
                setStatusYear(false) ;
                setStatusMonth(true)
                setStatusCalendar(false)
              }}
              style={{
                padding: "10px",height:"90px",
                backgroundColor: year === selectedYear ? "rgba(149, 143, 218,1)" : "#f0f0f0",
                color: year === selectedYear ? "white" : "black",
                borderRadius: "5px",
                border: "1px solid #ddd",
                cursor: "pointer"
              }}
            >
              {year}
            </button>
          ))}
        </div>
      </div>
    );
  }
  function MonthGrid({ onSelectMonth, selectedMonth }) {
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    return (<>  <div style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" ,display: "flex", justifyContent: "space-between", marginBottom: "10px",marginTop: "10px"  }}>
       
        <div  onClick={()=>{setStatusYear(false)
            setStatusMonth(false);
        setStatusCalendar(true)}} 
        style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
        ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
        
              <div style={{padding:"5px"}}>Select Month</div>
             <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
    
            </div> 
      <div style={{width:"320px", padding:"10px",display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "10px"
       ,boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" }}>
        {months.map((month, index) => (
          <button
            key={month}
            onClick={() => onSelectMonth(index)}
            style={{
              padding: "10px",
              backgroundColor: index === selectedMonth ? "rgba(149, 143, 218,1)" : "#f0f0f0",
              color: index === selectedMonth ? "white" : "black",
              borderRadius: "5px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            {month}
          </button>
        ))}
      </div>
      </>);
  }
   
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className=" contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
 <div  className=" " >
   {/* <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Now You Can Add Both Price And Membership Plans For <span className="coloredTextV1" > {TypeTitle}</span> </h2>
 <div className="gridFiftyFixed"style={{
       
      }}><div style={{  transform: animate ? 'scale(1)' : 'scale(.91)',
          opacity: animate ? 1 : 0.8,
          transition: 'transform 1s ease, opacity 1s ease',}}>
   <AppMenuCardBlueBG  activeCard={""} icon={5} title ="Add Price " onClickPopup={
            ()=>{ history.push(`${baseUrl}/price`) 
            }}  /></div>
  <div><AppMenuCardBlueBGTwo activeCard={""} icon={1} title ="Membership" onClickPopup={
          ()=>{ history.push(`${baseUrl}/membership-plan`)
          }}  /></div> 
          
   
   </div>  */}
     <div   className=" progress-bar-container "> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){
            history.push(`${baseUrl}/price`)
          }else if(step?.number==2){
            history.push(`${baseUrl}/expiry`)
          }else if(step?.number==3){
            history.push(`${baseUrl}/upsale`)
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"50%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div><br/>
      {pricePlanTypeStatus?<div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"10px"}}>
     
 <div className="gridForWhatsNextAfterYT2"> 
 <div >  <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   Make Your <span className="coloredTextV1" > {TypeTitle}</span> FREE or PAID??? </h2>
      <h4 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,color:"rgba(86, 82, 131,0.7)",
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Import Price Plan From Templates </h4></div>
      <div  className="ikcraft_login-input-card"style={{
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
 <div class="input-card-outer"style={{
            transform: animate ? 'translateY(0)' : 'translateY(10px)',
            opacity: animate ? 1 : 0.8,
            transition: 'transform 3s ease, opacity 3s ease',
          borderRadius:"25px",padding:"5px"}} >
                                    
                                    <div class="input-card-radio">
                                    <label onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                          <div >{loaderPriceType?.status?"loading...":"Free Plan"}</div> 
                                       
                                                <input type="radio" title="freePlan"  

          checked={pricePlanType=="freePlan"?"yes":""}
                                                 className="input-textbox"  value="freePlan"  name="coursePriceType"  
     onChange={e=>{
      
        handleCreatePricePlan("pricePlanType",e.target.value)
        setPricePlanType(e.target.value);
   
    
    }

       
    }
    />
                                                   <span class={"boxCardBorder"}></span>
                                          </label>
                                          <label onMouseEnter={()=>
                       handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                       <div  >{loaderPriceType?.status?"loading...":"Paid Plan"}</div> 
                                      
                                               <input  type="radio" title="paidPlan"  
                                       checked={pricePlanType=="paidPlan"?"yes":""}         className="input-textbox"  value="paidPlan" 
                                                 name="coursePriceType"  
                                                //  checked={freePaidStatus=="Paid"?true:false}
    onChange={e=>{
        handleCreatePricePlan("pricePlanType",e.target.value);
        setPricePlanType(e.target.value);
      }
      
   }
   />
                                                  <span class={"boxCardBorder"}></span>
                                         </label>



                                  
    </div> </div></div>

  </div>
  
  </div>:""}

  {pricePlanType=="paidPlan"?<div>
  <div  className="  PricePlanInputOuter"style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 1s ease',
      }}><div style={{background:"#f9f9f9",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Set Regular Price </h3>
      <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div> <input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Regular Price`} type="number"
    name="courseTitle" value={regularPriceWeb} onChange={(e)=>{
       setRegularPriceWeb(e.target.value) ;
       setDiscountPriceWeb(parseInt(discountPriceWeb)<e.target.value?parseInt(discountPriceWeb):"") ;
       setEffectivePriceWeb(parseInt(discountPriceWeb)<e.target.value?e.target.value-parseInt(discountPriceWeb):e.target.value)
       setDiscountStatusWeb(parseInt(discountPriceWeb)?e.target.value>parseInt(discountPriceWeb)?"":"Set Regular Price Higher ":"") ;
      setTimeout(()=>{ handleCreatePricePlan("priceWeb",{regularPriceWeb:e.target.value,
        discountPriceWeb:parseInt(discountPriceWeb)<e.target.value?parseInt(discountPriceWeb):"",
        effectivePriceWeb:parseInt(discountPriceWeb)<e.target.value?e.target.value-parseInt(discountPriceWeb):e.target.value

      });},100)
       } } /></div>
    </div><div style={{background:"#f9f9f9",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Set Discount    </h3>
        <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Discount Price`} type="number"
    name="courseTitle" value={discountPriceWeb} onChange={(e)=>{
       setDiscountPriceWeb(parseInt(regularPriceWeb)>e.target.value?e.target.value:"") ;
       setDiscountStatusWeb(parseInt(regularPriceWeb)>e.target.value?"":"Set Regular Price Higher ") ;
       setEffectivePriceWeb((parseInt(regularPriceWeb)>e.target.value?regularPriceWeb-e.target.value:regularPriceWeb))
       setTimeout(()=>{ handleCreatePricePlan("priceWeb",{regularPriceWeb:parseInt(regularPriceWeb),
        discountPriceWeb:parseInt(regularPriceWeb)>e.target.value?e.target.value:"",
        effectivePriceWeb:(parseInt(regularPriceWeb)>e.target.value?regularPriceWeb-e.target.value:regularPriceWeb)

      });},100)  } } /></div> 
       <h4 style={{"textAlign":"center",}}>{discountStatusWeb}</h4>
    </div><div style={{background:"#f9f9f9",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> <span className="coloredTextV1" > ₹ </span> Effective  Sale Price   </h3>
       <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Effective Price`} type="number"
    name="courseTitle" value={effectivePriceWeb} disabled /> </div>
    </div>

  </div>
  <div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"5px",paddingBottom:"50px"}}>
        
        <div className="gridForWhatsNextAfterYT2"> 
        <div > 
        <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  On Which Devices You Want To Enable/ Disable Sale ??? </h3>
         <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusplatformWeb?"loading...":"Set Salable On Website"} </h4></div>
      <Toggle state={platformWeb} toggleState={(state)=>{handleCreatePricePlan("platformWeb",state)}} />
         </div>
           <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusPlatformAndroid?"loading...":"Set Salable On Android"} </h4></div>
      <Toggle state={platformAndroid} toggleState={(state)=>{handleCreatePricePlan("platformAndroid",state)}} />
         </div>  <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusPlatformiOS?"loading...":"Set Salable On iOS"} </h4></div>
      <Toggle state={platformiOS} toggleState={(state)=>{handleCreatePricePlan("platformiOS",state)}} />
         </div>  
            </div>
  <div style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',marginBottom:"0px",
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}> <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Discount Price Validity ??? </h2> <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusDiscountSchedule?"loading...":"Set Discount Schedule"} </h4></div>
      <Toggle state={setDiscountScheduleStatus} toggleState={(state)=>{handleCreatePricePlan("setDiscountScheduleStatus",state)}} />
         </div>{setDiscountScheduleStatus? <div  >
          <div style={{display:"flex",justifyContent:"center"}} ><div>
          {statusMonth?<MonthGrid onSelectMonth={handleSelectMonth} selectedMonth={selectedMonth} />
     :""} </div> </div>  <div style={{display:"flex",justifyContent:"center"}} > <div>
        
    {statusYear?<YearGrid
        startYear={startYear}
        onSelectYear={setSelectedYear}
        selectedYear={selectedYear}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />  :""} </div> </div>{statusCalendar?<div><div style={{display:"flex",justifyContent:"center",}} > 
    <nav  style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" , display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px", marginBottom: "10px" ,marginTop: "10px" }} aria-label="">
      <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
      <div 
      style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(false)
        setStatusMonth(true);
    setStatusCalendar(false)}}>Change Month</div>
    
     <div  style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth-1)} } ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     <div style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth+1)} } > <ChevronRight style={{marginLeft:"1px"}} color="rgba(149, 143, 218,1)" size={30}/></div>
      </nav></div>
      <div style={{display:"flex",justifyContent:"center",}}><DayPicker 
           //   fromYear={1900}  // Start year for the dropdown
           //   toYear={2100}    // End year for the dropdown
           //   captionLayout="dropdown"  // Use dropdown layout for month and year
        
             numberOfMonths={1}
               mode="range"
               selected={selectedDate}
               onSelect={(date)=>{setSelectedDate(date)
                   setStartDate(formatDateString(date?.from));
         
                   setEndDate(formatDateString(date?.to))
                   handleDayClick(date)
                   
                }}
               month={new Date(selectedYear, selectedMonth)}// Show the selected year in the calendar
               modifiers={modifiers}
               labelsFormatters={{
                 formatWeekdayName: (day) => day.toLocaleDateString("es-ES", { weekday: "short" })
               }} 
               styles={{
                   caption: { color: "#99cc99" },
                   day: { borderRadius: "50%" },
                  
                 }}
               components={{
             Caption: ({ month }) => <strong>{month.toLocaleString('default', { month: 'long' })}</strong>,
             Footer: () => <p>Select your preferred date.</p>
         
           }}
           
           onDayClick={()=>{}}
            disabled={[
                 { before: new Date() }, // Disable past dates
                 // { dayOfWeek: [0] } // Disable weekends
               ]}
               modifiersStyles={modifiersStyles}
               // dayContentRenderer={(day) => (
               //   <div style={{ textAlign: 'center' }}>
               //     {day.getDate()}
               //     {day.getDay() === 0 && <span role="img" aria-label="holiday">🌟</span>} {}
               //   </div>
               // )}
               // showWeekNumber
          
           // footer={<p>End of Calendar</p>}
           // renderDay={(day) => (
           //   <div style={{ position: "relative" }}>
           //     <span>{day.getDate()}</span>
           //     {day.getDate() === 1 && <span style={{ color: "red" }}>Start</span>}
           //   </div>
           // )}
                /> </div> </div>:""}</div>:""}</div></div>
                </div>
                
             
                <div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"5px",padding:"10px",addingBottom:"50px"}}>
                <div className="gridForWhatsNextAfterYT5"> 
              
<div>  <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Different Prices For Old Users Or Renewal Prices ??? </h3>
        
           <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><h4>{loader?.statusSetPricesDiffferentlyForRenewalUsers?"loading...":"Enable  Prices For Renewal Users"} </h4>
      <Toggle state={setPricesDiffferentlyForRenewalUsers} toggleState={(state)=>{handleCreatePricePlan("setPricesDiffferentlyForRenewalUsers",state)}} />
         </div><div style={{display:"flex",justifyContent:"center"}} >{setPricesDiffferentlyForRenewalUsers?<div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setAddDiffPricesForRenewalUsersPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"10px",background:"#333333",textAlign:"center"
    ,width:"200px",fontWeight:"999",color:"#ffffff",
    fontSize:"17px",borderRadius:"5px",position:"relative",zIndex:"9999"
 ,marginRight:"10px",cursor:"pointer"}}>Set 
  Prices For Renewal Users </div>:""} </div> </div>  
                
<div>
<h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Different Prices For Android & iOS Devices ??? </h3>
          <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><h4>{loader?.statusSetPricesDiffferentlyForPlatforms?"loading...":"Enable Platform Specific Prices"} </h4>
      <Toggle state={setPricesDiffferentlyForPlatforms} toggleState={(state)=>{handleCreatePricePlan("setPricesDiffferentlyForPlatforms",state)}} />
         </div><div style={{display:"flex",justifyContent:"center"}} >{setPricesDiffferentlyForPlatforms&&(platformAndroid||platformiOS)?<div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setAddDiffPricesForDevicesPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"10px",background:"#333333",textAlign:"center"
    ,width:"200px",fontWeight:"999",color:"#ffffff",
    fontSize:"17px",borderRadius:"5px",position:"relative",zIndex:"9999"
 ,marginRight:"10px",cursor:"pointer"}}>Set 
  Prices For {platformAndroid?"Android":""}{platformAndroid&&platformiOS?" & ":""}{platformiOS?"iOS":""} </div>:!setPricesDiffferentlyForPlatforms?"":"First Make Salabel On Android Or iOS Platform"} </div> </div>  </div>  
            </div>
            <div className="gridForWhatsNextAfterYT2"> 
                <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Want To Create Installment Plan For Buyers ??? </h3>
        
<div>
           <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><h4>{loader?.statusAllowInstallmentPrices?"loading...":"Enable Installment Prices"} </h4>
      <Toggle state={allowInstallmentPrices} toggleState={(state)=>{handleCreatePricePlan("allowInstallmentPrices",state)}} />
         </div><div style={{display:"flex",justifyContent:"center"}} > </div> </div>  </div>  
        {allowInstallmentPrices? <div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-10px))',
     opacity: animate ? 1 : 0.8,
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="gridForSubCourseSkills" >
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id} 
          >
          
           <InstallmentPlanAddMore itemArr={item}index={index} key={item.id} 
        
         value={item.value}  id={item.id} 
           changeItemValue={updateItemValue } onRemove={removeItem} />
          </div>
          
          )):'' }
          </div>
    <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Installment</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      ,  value:{amount:1000,validityCount:1,validityDurationType:"months"} }]);
      handleCreatePricePlan("installmentValues",[...itemArr, {no: itemArr.length, id: generateTimestamp()+2
        ,  value:{amount:1000,validityCount:1,validityDurationType:"months"} }])}}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div> :""}
             
  {addDiffPricesForRenewalUsersPopUp? <div>    <div  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  className="selectThumbImgOuterAll"  onClick={()=>setAddDiffPricesForRenewalUsersPopUp(false)}  style={{zIndex:99999,cursor:"pointer",}}>
 </div>
  
    <div  className="CreateChaptersPopUpOuter"  style={{zIndex:"999999",background:"#ffffff"}}>
 <div className="SettingsPopUpTopFixed" > <h1 style={{float:"left",margin:"10px",paddingLeft:"15px"}}>Add Renewal Prices</h1><div onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",zIndex:"999999",position:"relative",
         borderRadius:"50%",float:"right",margin:"10px",
       background:"#958FDA"}} onClick={()=>setAddDiffPricesForRenewalUsersPopUp(false)}   >
         <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
         </div>   <div className="SettingsPopUpMiddleFixed" style={{}}>
      
 {  <div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"5px",paddingBottom:"50px"}}>
        
  <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Different Prices For Renewal Users</h3>
   <div  className="  PricePlanInputOuter"style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 1s ease',
      }}><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Regular Price For Renewal Users </h3>
      <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div> <input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Regular Price`} type="number"
    name="courseTitle" value={regularPriceRenewalUsers} onChange={(e)=>{
       setRegularPriceRenewalUsers(e.target.value) ;
       setDiscountPriceRenewalUsers(parseInt(discountPriceRenewalUsers)<e.target.value?parseInt(discountPriceRenewalUsers):"") ;
       setEffectivePriceRenewalUsers(parseInt(discountPriceRenewalUsers)<e.target.value?e.target.value-parseInt(discountPriceRenewalUsers):e.target.value)
       setDiscountStatusRenewalUsers(parseInt(discountPriceRenewalUsers)?e.target.value>parseInt(discountPriceRenewalUsers)?"":"Set Regular Price Higher ":"") ;
      setTimeout(()=>{ handleCreatePricePlan("priceRenewalUsers",{regularPriceRenewalUsers:e.target.value,
        discountPriceRenewalUsers:parseInt(discountPriceRenewalUsers)<e.target.value?parseInt(discountPriceRenewalUsers):"",
        effectivePriceRenewalUsers:parseInt(discountPriceRenewalUsers)<e.target.value?e.target.value-parseInt(discountPriceRenewalUsers):e.target.value

      });},100)
       } } /></div>
    </div><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Set Discount  For Renewal Users   </h3>
        <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Discount Price`} type="number"
    name="courseTitle" value={discountPriceRenewalUsers} onChange={(e)=>{
       setDiscountPriceRenewalUsers(parseInt(regularPriceRenewalUsers)>e.target.value?e.target.value:"") ;
       setDiscountStatusRenewalUsers(parseInt(regularPriceRenewalUsers)>e.target.value?"":"Set Regular Price Higher ") ;
       setEffectivePriceRenewalUsers((parseInt(regularPriceRenewalUsers)>e.target.value?regularPriceRenewalUsers-e.target.value:regularPriceRenewalUsers))
       setTimeout(()=>{ handleCreatePricePlan("priceRenewalUsers",{regularPriceRenewalUsers:parseInt(regularPriceRenewalUsers),
        discountPriceRenewalUsers:parseInt(regularPriceRenewalUsers)>e.target.value?e.target.value:"",
        effectivePriceRenewalUsers:(parseInt(regularPriceRenewalUsers)>e.target.value?regularPriceRenewalUsers-e.target.value:regularPriceRenewalUsers)

      });},100)  } } /></div> 
       <h4 style={{"textAlign":"center",}}>{discountStatusRenewalUsers}</h4>
    </div><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> <span className="coloredTextV1" > ₹ </span> Effective Price  For Renewal Users   </h3>
       <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Effective Price`} type="number"
    name="courseTitle" value={effectivePriceRenewalUsers} disabled /> </div>
    </div></div> 

  </div>}    </div>
  <div className="SettingsPopUpBottomFixed"> 
         <div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setAddDiffPricesForDevicesPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"15px",background:"rgba(144, 202, 249,1)",textAlign:"center"
    ,width:"200px",fontWeight:"999",color:"#ffffff",
    fontSize:"17px",borderRadius:"5px",position:"absolute",zIndex:"9999",right:"10px"
 ,margin:"10px",cursor:"pointer"}}>Save And Close
         </div> 
         </div>
  
  </div></div>:""}  
             
             
             
             
                {platformAndroid||platformiOS?
                <div  style={{borderRadius:"25px",margin:"5px",paddingBottom:"50px"}}>
                    {addDiffPricesForDevicesPopUp? <div>    <div  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  className="selectThumbImgOuterAll"  onClick={()=>setAddDiffPricesForDevicesPopUp(false)}  style={{zIndex:99999,cursor:"pointer",}}>
 </div>
  
    <div  className="CreateChaptersPopUpOuter"  style={{zIndex:"999999",background:"#ffffff"}}>
 <div className="SettingsPopUpTopFixed" > <h2 style={{float:"left",margin:"10px",paddingLeft:"15px",fontSize:"28px"}}>Add {platformAndroid?"Android":""}{platformAndroid&&platformiOS?" & ":""}{platformiOS?"iOS":""}  Prices</h2><div onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",zIndex:"999999",position:"relative",
         borderRadius:"50%",float:"right",margin:"10px",
       background:"#958FDA"}} onClick={()=>setAddDiffPricesForDevicesPopUp(false)}   >
         <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
         </div>   <div className="SettingsPopUpMiddleFixed" style={{}}>
      {platformAndroid?  
 <div   className="" >
             
                
                <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Different Prices For Android Device</h3>


         <div  className="  PricePlanInputOuter"style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 1s ease',
      }}><div style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Regular Price For Android</h3>
      <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div> <input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Regular Price`} type="number"
    name="courseTitle" value={regularPriceAndroid} onChange={(e)=>{
       setRegularPriceAndroid(e.target.value) ;
       setDiscountPriceAndroid(parseInt(discountPriceAndroid)<e.target.value?parseInt(discountPriceAndroid):"") ;
       setEffectivePriceAndroid(parseInt(discountPriceAndroid)<e.target.value?e.target.value-parseInt(discountPriceAndroid):e.target.value)
       setDiscountStatusAndroid(parseInt(discountPriceAndroid)?e.target.value>parseInt(discountPriceAndroid)?"":"Set Regular Price Higher ":"") ;
      setTimeout(()=>{ handleCreatePricePlan("priceAndroid",{regularPriceAndroid:e.target.value,
        discountPriceAndroid:parseInt(discountPriceAndroid)<e.target.value?parseInt(discountPriceAndroid):"",
        effectivePriceAndroid:parseInt(discountPriceAndroid)<e.target.value?e.target.value-parseInt(discountPriceAndroid):e.target.value

      });},100)
       } } /></div>
    </div><div style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",padding:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Set Discount For Android  </h3>
        <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Discount Price`} type="number"
    name="courseTitle" value={discountPriceAndroid} onChange={(e)=>{
       setDiscountPriceAndroid(parseInt(regularPriceAndroid)>e.target.value?e.target.value:"") ;
       setDiscountStatusAndroid(parseInt(regularPriceAndroid)>e.target.value?"":"Set Regular Price Higher ") ;
       setEffectivePriceAndroid((parseInt(regularPriceAndroid)>e.target.value?regularPriceAndroid-e.target.value:regularPriceAndroid))
       setTimeout(()=>{ handleCreatePricePlan("priceAndroid",{regularPriceAndroid:parseInt(regularPriceAndroid),
        discountPriceAndroid:parseInt(regularPriceAndroid)>e.target.value?e.target.value:"",
        effectivePriceAndroid:(parseInt(regularPriceAndroid)>e.target.value?regularPriceAndroid-e.target.value:regularPriceAndroid)

      });},100)  } } /></div> 
       <h4 style={{"textAlign":"center",}}>{discountStatusAndroid}</h4>
    </div><div style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> <span className="coloredTextV1" > ₹ </span> Effective Price For Android   </h3>
       <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Effective Price`} type="number"
    name="courseTitle" value={effectivePriceAndroid} disabled /> </div>
    </div>

  </div>    </div>:""}
 {platformiOS?  <div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"5px",paddingBottom:"50px"}}>
        
  <h3 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Different Prices For iOS Device</h3>
   <div  className="  PricePlanInputOuter"style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 1s ease',
      }}><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Regular Price For iOS </h3>
      <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div> <input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Regular Price`} type="number"
    name="courseTitle" value={regularPriceiOS} onChange={(e)=>{
       setRegularPriceiOS(e.target.value) ;
       setDiscountPriceiOS(parseInt(discountPriceiOS)<e.target.value?parseInt(discountPriceiOS):"") ;
       setEffectivePriceiOS(parseInt(discountPriceiOS)<e.target.value?e.target.value-parseInt(discountPriceiOS):e.target.value)
       setDiscountStatusiOS(parseInt(discountPriceiOS)?e.target.value>parseInt(discountPriceiOS)?"":"Set Regular Price Higher ":"") ;
      setTimeout(()=>{ handleCreatePricePlan("priceiOS",{regularPriceiOS:e.target.value,
        discountPriceiOS:parseInt(discountPriceiOS)<e.target.value?parseInt(discountPriceiOS):"",
        effectivePriceiOS:parseInt(discountPriceiOS)<e.target.value?e.target.value-parseInt(discountPriceiOS):e.target.value

      });},100)
       } } /></div>
    </div><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><span className="coloredTextV1" > ₹ </span> Set Discount  For iOS    </h3>
        <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Discount Price`} type="number"
    name="courseTitle" value={discountPriceiOS} onChange={(e)=>{
       setDiscountPriceiOS(parseInt(regularPriceiOS)>e.target.value?e.target.value:"") ;
       setDiscountStatusiOS(parseInt(regularPriceiOS)>e.target.value?"":"Set Regular Price Higher ") ;
       setEffectivePriceiOS((parseInt(regularPriceiOS)>e.target.value?regularPriceiOS-e.target.value:regularPriceiOS))
       setTimeout(()=>{ handleCreatePricePlan("priceiOS",{regularPriceiOS:parseInt(regularPriceiOS),
        discountPriceiOS:parseInt(regularPriceiOS)>e.target.value?e.target.value:"",
        effectivePriceiOS:(parseInt(regularPriceiOS)>e.target.value?regularPriceiOS-e.target.value:regularPriceiOS)

      });},100)  } } /></div> 
       <h4 style={{"textAlign":"center",}}>{discountStatusiOS}</h4>
    </div><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",margin:"10px",paddingBottom:"20px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> <span className="coloredTextV1" > ₹ </span> Effective Price  For iOS   </h3>
       <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
    opacity: animate ? 1 : 0.8,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>₹</div><input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
         transform: animate ? 'scale(1)' : 'scale(.98)',marginBottom:"0px",
         opacity: animate ? 1 : 0.8,
         transition: 'transform 1s ease, opacity 1s ease',
       fontSize:"20px",width:"150px"}} placeholder={`₹ Effective Price`} type="number"
    name="courseTitle" value={effectivePriceiOS} disabled /> </div>
    </div></div> 

  </div>:""}  
  
 
  
    </div>
  <div className="SettingsPopUpBottomFixed"> 
         <div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setAddDiffPricesForDevicesPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"15px",background:"rgba(144, 202, 249,1)",textAlign:"center"
    ,width:"200px",fontWeight:"999",color:"#ffffff",
    fontSize:"17px",borderRadius:"5px",position:"absolute",zIndex:"9999",right:"10px"
 ,margin:"10px",cursor:"pointer"}}>Save And Close
         </div> 
         </div>
  
  </div></div>:""}
  </div>:""}</div>:""}
  <div style={{height:"110px"}}></div>
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px",padding:"15px 10px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Go To Set Expiry"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Create Mock Tests & Add Contents.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/approx-material`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default CreatePricePlan;

